import { Button } from "primereact/button";
import React from "react";
import { IHeaderBarProps } from "../types/IHeaderBar";
import styles from "./HeaderBar.module.css";
import logo from "../assets/idwal-logo.svg";
import presaleLogo from "../assets/pre-sale-logo.svg";
import fleetLogo from "../assets/idwal-fleet-logo.svg";
import adminLogo from "../assets/idwal-admin-logo.svg";
import idLogo from "../assets/idwal-id-logo.svg";
import idLogoSolo from "../assets/id-logo-solo.svg";

/**
 * Main header component, prop determines whether the menu is showing.
 */
export const HeaderBar = (props: IHeaderBarProps) => {
    const showBurgerMenu = () => {
        if (props.burgerMenu) {
            return (
                <div className={`flex flex-row-reverse`}>
                    <Button
                        data-testid="header-burgermenu-icon"
                        className="p-button-rounded p-button-text"
                        icon="pi pi-bars"
                        onClick={props.onClick}
                    ></Button>
                </div>
            );
        }
        return <></>;
    };

    const headerLogo = () => {
        if (props.logo === "main") {
            return logo;
        } else if (props.logo === "presale") {
            return presaleLogo;
        } else if (props.logo === "fleet") {
            return fleetLogo;
        } else if (props.logo === "admin") {
            return adminLogo;
        } else if (props.logo === "id") {
            return idLogo;
        } else if (props.logo === "id-solo") {
            return idLogoSolo;
        }
        // Use regular logo as default if logo isn't valid or is not provided
        return logo;
    };

    return (
        <header
            className={`${styles.logoContainer} ${
                props.className ?? "bg-white w-full"
            }`}
            data-cy="header"
        >
            <div
                className={`${
                    props.size === "large"
                        ? "px-4 lg:px-5 dashboard"
                        : "max-width-wrapper"
                } flex justify-content-between align-items-center`}
            >
                <img className={styles.idwalLogo} src={headerLogo()} />
                {showBurgerMenu()}
            </div>
        </header>
    );
};
